import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({
  baseURL: API,
  withCredentials: true, // send cookies for auth
});

// Attach error normalisation
http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response) {
      err.apiMessage = err.response.data?.detail || err.response.statusText;
    } else {
      err.apiMessage = err.message || 'Network error';
    }
    return Promise.reject(err);
  }
);

export const api = {
  // Auth
  me: () => http.get('/auth/me').then((r) => r.data.user),
  loginWithSessionId: (session_id) => http.post('/auth/session', { session_id }).then((r) => r.data.user),
  demoLogin: (email) => http.post('/auth/demo-login', { email }).then((r) => r.data.user),
  logout: () => http.post('/auth/logout'),

  // Users
  listUsers: () => http.get('/users').then((r) => r.data.users),

  // Clients
  listClients: () => http.get('/clients').then((r) => r.data.clients),
  createClient: (body) => http.post('/clients', body).then((r) => r.data.client),
  getClient: (id) => http.get(`/clients/${id}`).then((r) => r.data.client),
  patchClient: (id, body) => http.patch(`/clients/${id}`, body).then((r) => r.data.client),

  // Sessions
  listSessions: (params = {}) => http.get('/sessions', { params }).then((r) => r.data.sessions),
  createSession: (body) => http.post('/sessions', body).then((r) => r.data.session),
  getSession: (id) => http.get(`/sessions/${id}`).then((r) => r.data.session),
  patchSession: (id, body) => http.patch(`/sessions/${id}`, body).then((r) => r.data.session),
  addConversation: (id, text) => http.post(`/sessions/${id}/conversation`, { text }).then((r) => r.data.session),

  // Signed report
  uploadSignedReport: (id, file, onProgress) => {
    const fd = new FormData();
    fd.append('file', file);
    return http.post(`/sessions/${id}/signed-report`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    }).then((r) => r.data.signed_report);
  },
  deleteSignedReport: (id) => http.delete(`/sessions/${id}/signed-report`),
  signedReportUrl: (id) => `${API}/sessions/${id}/signed-report`,

  // Alerts
  listAlerts: () => http.get('/alerts').then((r) => r.data.alerts),

  // Leaderboard
  rmLeaderboard: (month) => http.get('/admin/rm-leaderboard', { params: month ? { month } : {} }).then((r) => r.data),

  // Client pre-meeting form
  createPrefillLink: (sid, regenerate = false) => http.post(`/sessions/${sid}/prefill/link`, null, { params: regenerate ? { regenerate: true } : {} }).then((r) => r.data),
  getPrefill: (sid, token) => http.get(`/prefill/${sid}`, { params: { token } }).then((r) => r.data),
  submitPrefill: (sid, token, body) => http.post(`/prefill/${sid}`, body, { params: { token } }).then((r) => r.data),

  // Compliance
  auditDraftDownload: (sid) => http.post(`/sessions/${sid}/audit/draft-download`).then((r) => r.data),
  listDraftDownloads: (sid) => http.get(`/sessions/${sid}/audit/draft-downloads`).then((r) => r.data),

  // Audit
  exportAuditUrl: () => `${API}/audit/export`,
};

export default api;
